const RecentInsightsSkelton=()=>{
    const numArray = Array.from({ length: 6 }, (_, index) => index + 1);
    return(
        <>
            {
                numArray.map((num)=>{
                    return(
                        <div key={num} className="mb-4 md:mb-0 recent-tile">
                            <a href="#">
                                <div className="blue-gr-box alim-interactive-tile">
                                    <div className="alim-font-color-style text-xs dark:text-opacity-75 mb-2 truncate relative">
                                        <span className="invisible">demo</span>
                                        <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer h-1 top-1.5"></div>
                                    </div>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="col-span-1 overflow-hidden">
                                            <div className="alim-font-color-style text-xs font-medium relative">
                                                <span className="invisible">demo</span>
                                                <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer h-1 top-1.5"></div>
                                            </div>
                                        </div>
                                        <div className="col-span-1 overflow-hidden">
                                            <div className="alim-font-color-style text-xs font-medium relative">
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="alim-font-color-style text-xs font-medium relative overflow-hidden">
                                        <span className="invisible">demo</span>
                                        <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer h-1 top-1.5"></div>
                                    </div>
                                    <div className="text-center py-4 px-2 mt-3 rounded recent-inner">
                                        <div className="text-base font-medium mb-1 font-extrabold relative overflow-hidden">
                                            <span className="invisible">demo</span>
                                            <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer h-3 top-1.5"></div>
                                        </div>
                                        <div className="text-opacity-75 text-xs font-medium relative overflow-hidden">
                                            <span className="invisible">demo</span>
                                            <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer h-1 top-1.5"></div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    )
                })
            }
        </>
    );
}

export default RecentInsightsSkelton;